export enum DocumentRequestStatus {
  PENDING = 'pending',
  VALIDATED = 'validated'
}

export enum DocumentTypes {
  Alfresco = 'alfresco',
}

export enum DocumentStatus {
  WAITING='waiting',
  UPLOADED = 'uploaded',
  PENDING = 'pending'
}

export interface DocumentInterface {
  title: string;
  description?: string;
  data?: any;
  type: DocumentTypes;
  status: DocumentStatus;
  receiver: string;
  receivermails:string;
}

export interface DocumentRequestInterface {
  title: string;
  sender: any;
  sendermail:string;
  expireDate:any;
  type?:string;
  description?: string;
  documents: DocumentInterface[];
  container: any;
  status: DocumentRequestStatus;
  receiver: string;
  receivermails:string;
  receiversArray?: any;
}
